$(document).bind('_js_ready popin', function() {
	const slider = $('.slider-for-videos');

	slider.each(function(index) {

        // Compteur de slide
			let uid = $(this).closest('.diaporama_videos').attr('data-uid');
			let counter = $('#slide_video_counter_' + uid);
			$(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
				let i = (currentSlide ? currentSlide : 0) + 1;
				counter.html('<p><span class="count_current">' + i + '</span> / <span class="count_total">' + slick.slideCount + '</span>');
			});

		$(this).not('.slick-initialized').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
            nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
			responsive: [
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

	});

	function loadNextVideo() {
		slider.find('.slick-active .video').each(function() {
			if ($(this).hasClass("external_vid")) {
				$(this).addClass("lazy");
			} else {
				$(this).children("video").addClass("lazy");
			}
		});
		animate();
	} loadNextVideo();

	slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
		loadNextVideo();
	});
});